export default __webpack_public_path__ + "static/media/eur.a45a98cf.svg";